import { FC, useState } from 'react'
import { Grid } from '@mui/material'

import { ConfiguredEntityPage } from '@pages/ConfiguredEntityPage'

import { CONTEXT_MODEL_TYPE, ENTITY } from '@constants'
import { GETDefaultBackgroundEntity, POSTObjectDataFilter } from '@types'

type ConfiguredEntitiesPageProps = {
  path: string
  entities: GETDefaultBackgroundEntity[]
}

export const ConfiguredEntities: FC<ConfiguredEntitiesPageProps> = ({ path, entities }) => {
  const [searchFilterBody, setSearchFilterBody] = useState<POSTObjectDataFilter>(null)

  const bothEntitiesIsView =
    entities[0].type === CONTEXT_MODEL_TYPE.VIEW && entities[1].type === CONTEXT_MODEL_TYPE.VIEW

  const entityByType = (entity: GETDefaultBackgroundEntity, index: number) => {
    if (entity.type === CONTEXT_MODEL_TYPE.VIEW) {
      return (
        <ConfiguredEntityPage
          key={path}
          entityCode={entity.code as string}
          entityId={entity.sourceId as number}
          entityMinHeight={'90%'}
          hideSA={bothEntitiesIsView && index === 1}
          path={path}
          title={entity.title as string}
          type={ENTITY.VIEW}
          {...(bothEntitiesIsView &&
            index === 0 && {
              setSearchFilter: setSearchFilterBody,
            })}
          {...(bothEntitiesIsView &&
            index === 1 && {
              searchFilterBody,
            })}
        />
      )
    }

    return null
  }

  return (
    <Grid height='100%'>
      {entities.map((entity, index) => (
        <Grid
          key={entity.id}
          sx={{ height: '50%', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}
        >
          {entityByType(entity, index)}
        </Grid>
      ))}
    </Grid>
  )
}
